export default __webpack_public_path__ + "static/media/empty-betslip.c008278f.svg";